import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CouponCardComponent } from './coupon-card.component';



@NgModule({
  declarations: [CouponCardComponent],
  imports: [
    CommonModule
  ],
  exports: [CouponCardComponent]
})
export class CouponCardModule { }
